import React from 'react';
import EmbedVideo from './embed-video/embed-video';
import Direction from './direction/direction';
import I18nProvider from '../i18n/i18n.provider';
import { createInstance } from '../bi';
import { ExperimentsLoader } from './experiments-loader/experiments-loader';

// create BI instance before rendering application
createInstance();

const App = () => {
  return (
    <ExperimentsLoader>
      <Direction>
        <I18nProvider>
          <EmbedVideo />
        </I18nProvider>
      </Direction>
    </ExperimentsLoader>
  );
};

export default App;
